import { useDispatch, useSelector } from 'store';
import { setLang } from 'store/reducers/langSlice';
import i18n from 'i18n';
import { Lang } from 'types/globalTypes';
import { useNavigate } from 'react-router';

const useLang = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { currentLang } = useSelector((state) => state.lang);

  const changeLanguage = (lang: Lang) => {
    i18n.changeLanguage(lang);
    dispatch(setLang(lang));
    const newPath = `/${lang}${window.location.pathname.slice(3)}`;
    navigate(newPath);
  };

  return { currentLang, changeLanguage };
};

export default useLang;
